import { TReasoningEffort } from '../types/TReasoningEffort';
import { getSupportedReasoningEfforts } from './getSupportedReasoningEfforts';

export const getReasoningEffortForModelChange = (
  model: string,
  currentEffort: TReasoningEffort | null | undefined,
): null | undefined =>
  currentEffort && !getSupportedReasoningEfforts(model).includes(currentEffort) ? null : undefined;
